import { render, staticRenderFns } from "./Golarger.vue?vue&type=template&id=3c9c4a98&"
import script from "./Golarger.vue?vue&type=script&lang=js&"
export * from "./Golarger.vue?vue&type=script&lang=js&"
import style0 from "./Golarger.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports